export interface SubmissionType {
  id: number;
  user_id: number;
  user_client_id: number;
  sponsor_id: number;
  import_comment: string;
  role: string;
  error_message?: string;
  file_path: string;
  status: string;
  created_at: string;
  signed_url: string;
}

export interface PayloadSubmissionsType {
  loading: boolean;
  submissions?: Array<SubmissionType>;
}

export interface FetchSubmissionsType {
  user_client_id: number;
  sponsor_id: number;
}

export const APIErrorsMessage = [
  "Ligne d'en tête de données non trouvée",
  'Veuillez soumettre un fichier au format xlsx'
];
